import dl from "../utils/device-language";
import qs from 'qs';
import apiClient from "./api-client";
import { ANALYTICSENDPOINT } from "./constants";
import formats from "../utils/formats";

async function checkSession() {
    const now = Date.now();

    let lastSession = window.localStorage.getItem("__user_session__");

    if (lastSession) {
        lastSession = JSON.parse(lastSession);

        if (Math.abs(lastSession.time - now) <= 3600000) {
            window.localStorage.setItem("__user_session__", JSON.stringify({ token: lastSession.token, time: now }));
            return;
        }
    }

    try {
        window.localStorage.setItem("__user_session__", JSON.stringify({ token: formats.generateRandomID(""), time: now }));
        return await buildData(2, "k9i8jd78w", "usersession", {}, false);
    } catch (e) {
        return console.log(e);
    }
}

async function buildData(id, token, action, metadata, hasOrders) {
    var dataV2 = {
        "data": {
            "type": "webapplog",
            "attributes": {
                "ris_id": id,
                "token": token,
                "action": action,
                "payload": {
                    "action": action,
                    "attributes": [process.env.REACT_APP_NAMESPACE, hasOrders ? "o&p" : "mcm"],
                    "domain": window.location.origin,
                    "lang": dl.getDeviceLanguage(),
                    "metadata": metadata ?? Object.assign({}, metadata),
                    "referrer": window.document.referrer,
                    "start": Date.now(),
                    "url": window.location.href,
                    "user_agent": navigator.userAgent
                }
            }
        }
    }

    if (
        "production" === process.env.NODE_ENV &&
        "test" !== process.env.REACT_APP_NAMESPACE
    ) {
        try {
            return await apiClient.doPost(ANALYTICSENDPOINT, qs.stringify(dataV2), {
                mode: "no-cors",
                headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            })
        } catch (err) {
            console.log(err);
        }
    } else {
        console.log({ dataV2 });
    }

    return dataV2;
}

async function trackDataV2(id, token, action, metadata, hasOrders) {
    await checkSession();

    buildData(id, token, action, metadata, hasOrders);
}

export { trackDataV2 };
